import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";
export const styles = stylex.create({
  page: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 1200,
    marginInline: "auto",
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 768px)": spacing.space48,
    },
    paddingTop: {
      default: spacing.space48,
      "@media (min-width: 1024px)": spacing.space64,
    },
    paddingBottom: spacing.space48,
    color: colors.foreground,
    fontFamily: fonts.sans,
  },
  embedded: {
    minWidth: 0,
    width: "100%",
    fontFamily: fonts.sans,
    color: colors.foreground,
  },
  embeddedTitle: {
    fontSize: fontSizes.sectionTitle,
    fontFamily: fonts.sans,
    letterSpacing: "normal",
  },
  content: { minWidth: 0 },
  eyebrow: {
    margin: 0,
    marginBottom: spacing.space8,
    color: colors.muted,
    fontSize: fontSizes.label,
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    gap: spacing.space12,
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: spacing.space16,
  },
  loading: {
    display: "flex",
    alignItems: "center",
    gap: spacing.space8,
    paddingBlock: spacing.space32,
    color: colors.muted,
  },
  feedback: { marginBlock: spacing.space16 },
  alertContent: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.space12,
    justifyContent: "space-between",
  },
  score: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: 1.2,
    fontWeight: 600,
  },
  byline: {
    margin: 0,
    marginTop: spacing.space4,
    color: colors.muted,
    fontSize: fontSizes.caption,
    lineHeight: 1.7,
  },
  author: { color: colors.foreground, fontWeight: 600 },
  player: { fontFamily: fonts.mono, fontSize: fontSizes.caption },
  link: {
    color: colors.foreground,
    fontSize: fontSizes.small,
    textDecoration: "underline",
    textUnderlineOffset: 3,
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
  },
  attachment: {
    maxWidth: "100%",
    maxHeight: 360,
    objectFit: "contain",
    borderRadius: radii.small,
    display: "block",
    marginTop: spacing.space12,
  },
});
